import { toast } from 'react-toastify';
import { notificationsApi } from 'entities/notifications';
import { INotificationList } from 'features/userNotifications/types';

const getNotificationsApi = notificationsApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<INotificationList, { user_id: number; page: number; size: number; search: string }>(
      {
        query: ({ user_id, page, size, search }) => ({
          url: `/notifications/admin/notifications/${user_id}?page=${page}&size=${size}${
            search ? `&search=${search}` : ''
          }`,
        }),
        providesTags: ['Notifications'],
      },
    ),
    addNotification: builder.mutation({
      query: ({ data, id }: any) => ({
        url: `/notifications/admin/notifications/${id}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result: any, error: any) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Данные сохранены', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['Notifications'];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetNotificationsQuery, useAddNotificationMutation } = getNotificationsApi;
